"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('outlet', {
            url: '/outlet/:id',
            template: require('../views/outlet.html'),
            controller: 'OutletController',
            controllerAs: 'outlet',
            params: {
                id: { squash: true, value: null }
            },
            resolve: {
                categories: ['api', function (api) {
                        return api.get('/b2b/outlet/categories')
                            .then(function (items) {
                            return items;
                        }, function (err) {
                            console.log(err);
                        });
                    }],
                products: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/outlet/' + $stateParams.id + '/products')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return api.get('/b2b/outlet/products')
                                .then(function (items) {
                                return items;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                    }],
                category: ['$stateParams', 'api', function ($stateParams, api) {
                        if ($stateParams.id) {
                            return api.get('/b2b/categories/' + $stateParams.id)
                                .then(function (item) {
                                return item;
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return {};
                        }
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/outlet/config/routes.js
// module id = 382
// module chunks = 0